<td>
    <button (click)="onToggleExpand()" class="btn btn-sm" type="button">
        <fa-icon
            [fixedWidth]="true"
            [icon]="['far', 'angle-right']"
            [rotate]="expanded ? 90 : 0"
        ></fa-icon>
    </button>
</td>

<td class="py-3">
    <h6 class="m-0">{{ quotationOffer.carrier_name || 'Unknown carrier' }}</h6>
    <div>{{ quotationOffer.rate_name }}</div>
</td>

<td class="py-3">
    <div>{{ quotationOffer.pol.name }} - {{ quotationOffer.pod.name }}</div>
    <div>
        <ng-container *ngIf="quotationOffer.valid_from; else noDate">
            {{ quotationOffer.valid_from | amUtc | amDateFormat: 'LL' }}
        </ng-container>
        -
        <ng-container *ngIf="quotationOffer.valid_until; else noDate">
            {{ quotationOffer.valid_until | amUtc | amDateFormat: 'LL' }}
        </ng-container>
    </div>
    <ng-template #noDate>...</ng-template>
</td>

<td class="py-3 text-right">
    <div>
        {{ quotationOffer.total_buying | currency: quotationOffer.currency }}
    </div>
</td>

<td class="py-3 text-right">
    <div>
        {{ quotationOffer.total_amount | currency: quotationOffer.currency }}
    </div>
</td>

<td class="py-3 text-right">
    <div>
        {{ quotationOffer.total_margin | currency: quotationOffer.currency }}
    </div>
    <div *ngIf="quotationOffer.total_amount !== 0">
        {{
            quotationOffer.total_margin / quotationOffer.total_amount | percent:"0.2-2"
        }}
    </div>
</td>

<td class="py-3 text-center">
    <div class="d-inline-block">
        <button class="btn" (click)="menu.toggle($event)">
            <fa-icon
                [fixedWidth]="true"
                [icon]="['far', 'ellipsis-v']"
            ></fa-icon>
        </button>

        <p-overlayPanel #menu>
            <div *ngIf="!allowChange" class="small text-muted">
                <i>{{ 'hub.quotations.details.some-options-disabled' | translate }}</i>
            </div>
            <ul class="nav flex-column align-items-start">
                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a
                        class="pl-2 dropdown-item"
                        [attr.disabled]="!allowChange"
                        pTooltip="{{ 'hub.quotations.details.offer-cannot-be-edited-tooltip' | translate }}"
                        [tooltipDisabled]="allowChange"
                        [routerLink]="['./offers', quotationOffer.id]">
                        <fa-icon
                            [fixedWidth]="true"
                            [icon]="['far', 'pencil']"
                            class="mr-2"
                        ></fa-icon>
                        {{ 'common.edit' | translate }}
                    </a>
                </li>
                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a
                        class="pl-2 dropdown-item"
                        (click)="onDelete()"
                        href="javascript:void(0)"
                        [attr.disabled]="!allowChange"
                        pTooltip="{{ 'hub.quotations.details.offer-cannot-be-deleted-tooltip' | translate }}"
                        [tooltipDisabled]="allowChange"
                    >
                        <fa-icon
                            [fixedWidth]="true"
                            [icon]="['far', 'trash']"
                            class="mr-2"
                        ></fa-icon>
                        {{ 'common.delete' | translate }}
                    </a>
                </li>
                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a
                        class="pl-2 dropdown-item"
                        [routerLink]="['./offers', 'copy', quotationOffer.id]"
                    >
                        <fa-icon
                            [fixedWidth]="true"
                            [icon]="['far', 'copy']"
                            class="mr-2"
                        ></fa-icon>
                        {{ 'common.copy' | translate }}
                    </a>
                </li>
                <li class="nav-item px-3 pl-0 dropdown-item">
                    <a
                        class="pl-2 dropdown-item"
                        href="javascript:void(0)"
                       (click)="onGeneratePdf()">
                        <fa-icon
                            [fixedWidth]="true"
                            [icon]="['far', 'file-pdf']"
                            class="mr-2"
                        ></fa-icon>
                        {{ 'common.download' | translate }}
                    </a>
                </li>
            </ul>
        </p-overlayPanel>
    </div>
</td>
